<template>
  <div v-if="!logado"></div>
  <router-view v-else></router-view>
</template>

<script>
export default {
  name: 'Manuais',
  components: {},
  data () {
    return {
      logado: false
    }
  },
  methods: {},
  created: function () {
    this.logado = this.$root.auth
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Manuais.vue